import { auth } from '@/services/firebase.service'

import { SIGN_OUT } from './types'

export type SignOutActionType = {
  type: typeof SIGN_OUT
}

export const signOutAction = (): SignOutActionType => {
  auth.signOut()
  return {
    type: SIGN_OUT,
  }
}
